// extracted by mini-css-extract-plugin
export default {"tooltip":"BV-z","arrow":"CV-z"};